import type { IconSvgObject } from './types';

const ImagePlusIcon: IconSvgObject = [
  ["path", { d: "M21.5 18.5H18.5M18.5 18.5H15.5M18.5 18.5V15.5M18.5 18.5V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "7.5", cy: "7.5", r: "1.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5 21.5C7.35301 21.4981 5.22972 21.4473 3.89124 20.1088C2.5 18.7176 2.5 16.4784 2.5 12C2.5 7.52168 2.5 5.2825 3.89124 3.89125C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89125C21.5 5.2825 21.5 7.52168 21.5 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M13.0018 13.0616C10.1493 14.6467 7.70477 17.7414 5.41797 20.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default ImagePlusIcon;
